import apiClient from '../axios'

export async function list(page, countryId) {
  const countryQuery = countryId ? `/country/${countryId}` : '';

  return apiClient
    .get(`/coordinators${countryQuery}?page=${page}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function details(id) {
  return apiClient
    .get(`/coordinators/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function add(data) {
  return apiClient
    .put('/coordinators', data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function edit(id, data) {
  return apiClient
    .post(`/coordinators/${id}`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
